import CrudTable from "components/table/CrudTable";
import React, { useEffect, useState } from "react";
import AcademicYearForm from "./AcademicYearsForm";
import {
  createAcademicYear,
  deleteAcademicYear,
  fetchAcademicyears,
  updateAcademicYear,
} from "ServerAPI/serverAPI";
import { useToast } from "context/toast-context/ToastProvider";
import ToastMessage from "components/Dialog/ToastMessage";
import { useCookies } from "react-cookie";
import Moment from "react-moment";

const AcademicYears = () => {
  const [rows, setRows] = useState([]);
  const { showToast } = useToast();
  const [showToastMessage, setShowToastMessage] = useState(false);
  const [loading, setLoading] = useState(false);
  const [cookies] = useCookies();
  const [buttonLoading, setButtonLoading] = useState(false);

  const handleToastMessageClose = () => {
    setShowToastMessage(false);
  };

  const columns = [
    {
      field: "sno",
      headerName: "S.No",
      flex: 0.5,
      align: "center",
      headerAlign: "center",
      headerClassName: "table-header",
      editable: false,
    },
    {
      field: "name",
      headerName: "Name",
      flex: 1,
      align: "center",
      headerAlign: "center",
      headerClassName: "table-header",
      editable: false,
      renderCell: (params) => {
        if (!params.value) return "";
        return params.value
          .toString()
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ");
      },
    },
    {
      field: "startDate",
      headerName: "Start Date",
      flex: 1,
      align: "center",
      headerAlign: "center",
      headerClassName: "table-header",
      editable: false,
      renderCell: (params) => (
        <Moment format="DD/MM/YYYY">{params.value}</Moment>
      ),
    },
    {
      field: "endDate",
      headerName: "End Date",
      flex: 1,
      align: "center",
      headerAlign: "center",
      editable: false,
      headerClassName: "table-header",
      renderCell: (params) => (
        <Moment format="DD/MM/YYYY">{params.value}</Moment>
      ),
    },
    {
      field: "isCurrent",
      headerName: "Active",
      flex: 0.5,
      align: "center",
      headerAlign: "center",
      editable: false,
      headerClassName: "table-header",
      renderCell: (params) => (params.value ? "Yes" : "No"),
    },
  ];

  const handlefetchAcademicYears = async () => {
    const payload = {
      userId: cookies.userId,
    };
    setLoading(true);
    if (payload && payload.userId) {
      const response = await fetchAcademicyears(payload);
      if (response && response.status === "success") {
        const rowsWithSno = (response.data || []).map((row, index) => ({
          ...row,
          sno: index + 1,
        }));
        setRows(rowsWithSno || []);
        setLoading(false);
      } else {
        setRows([]);
        setLoading(false);
        showToast(
          response?.message || "Failed to fetch Academic Years",
          "error",
        );
      }
    } else {
      setRows([]);
      setLoading(false);
    }
  };

  useEffect(() => {
    handlefetchAcademicYears();
  }, [cookies.userId]);

  const handlecreateAcademicYear = async (data) => {
    const payload = {
      userId: cookies.userId,
      ...data,
    };
    setButtonLoading(true);
    const response = await createAcademicYear(payload);
    if (response && response.status === "success") {
      setRows((prevRows) => {
        const updatedPrevRows = response.data.isCurrent
          ? prevRows.map((row) => ({ ...row, isCurrent: false }))
          : prevRows;

        const updated = [response.data, ...updatedPrevRows];
        return updated.map((row, index) => ({ ...row, sno: index + 1 }));
      });
      setButtonLoading(false);
      showToast("Academic Year Created Successfully", "success");
      return true;
    } else {
      setButtonLoading(false);
      showToast(response?.message || "Failed to create Academic Year", "error");
      return false;
    }
  };

  const handledeleteAcademicYear = async (data) => {
    const payload = {
      userId: cookies.userId,
      academicYearId: data.academicYearId,
      action: "delete",
    };
    setLoading(true);
    const response = await deleteAcademicYear(payload);
    if (response && response.status === "success") {
      setRows((prevRows) => {
        const filtered = prevRows.filter(
          (row) => row.academicYearId !== payload.academicYearId,
        );
        return filtered.map((row, index) => ({ ...row, sno: index + 1 }));
      });
      setLoading(false);
      showToast("Academic Year Deleted Successfully", "success");
      return true;
    } else {
      setLoading(false);
      showToast(response?.message || "Failed to delete Academic Year", "error");
      return false;
    }
  };

  const handleUpdateAcademicYear = async (data) => {
    const payload = {
      userId: cookies.userId,
      action: "update",
      ...data,
    };
    setButtonLoading(true);
    const response = await updateAcademicYear(payload);
    if (response && response.status === "success") {
      setRows((prevRows) => {
        const updated = prevRows.map((row) => {
          if (row.academicYearId === data.academicYearId) {
            return response.data;
          }
          return response.data.isCurrent ? { ...row, isCurrent: false } : row;
        });
        return updated.map((row, index) => ({ ...row, sno: index + 1 }));
      });
      setButtonLoading(false);
      showToast("Academic Year Updated Successfully", "success");
      return true;
    } else {
      setButtonLoading(false);
      showToast(response?.message || "Failed to update Academic Year", "error");
      return false;
    }
  };

  return (
    <div className="container ms-auto my-5">
      <ToastMessage
        open={showToastMessage}
        message="Course Marked As Deleted"
        closeTiming={3000}
        handleClose={handleToastMessageClose}
      />
      <CrudTable
        rows={rows}
        columns={columns}
        onRefresh={handlefetchAcademicYears}
        loading={loading}
        createButtonText={"Create Academic Year"}
        FormComponent={AcademicYearForm}
        deleteButtonText={"Delete Academic Year"}
        handleSubmit={handlecreateAcademicYear}
        buttonLoading={buttonLoading}
        getRowId={(row) => row.academicYearId}
        handleDelete={handledeleteAcademicYear}
        onUpdate={handleUpdateAcademicYear}
        disable={cookies.roleId !== "organizationCoordinator"}
      />
    </div>
  );
};

export default AcademicYears;
